import {
  WithAnalyticsEventsProps,
  withAnalyticsEvents
} from '@atlaskit/analytics-next';
import { ButtonProps } from '@atlassiansox/wpl-utils';
import { Fragment, MouseEvent, useCallback } from 'react';
import { ANALYTICS_EVENTS } from '../../constants';
import { useModuleProps } from '../../module-props';
import { useGlobalStore } from '../../store';
import AddProduct from '../add-product';
import {
  containerStyles,
  mobileContainerStyles,
  restartButtonStyles
} from './restart-add-product.styles';

const RestartButtonBase = ({
  createAnalyticsEvent,
  onClick,
  text
}: WithAnalyticsEventsProps & ButtonProps) => {
  const handleClick = useCallback(
    async (event: MouseEvent) => {
      const analyticsEvent = createAnalyticsEvent?.({
        action: 'click',
        component: 'button',
        eventName: ANALYTICS_EVENTS.restartFlow
      });
      analyticsEvent?.fire();

      if (onClick) {
        onClick(event);
      }
    },
    [onClick, createAnalyticsEvent]
  );

  return (
    <button css={restartButtonStyles} onClick={handleClick}>
      {text}
    </button>
  );
};

const RestartButton = withAnalyticsEvents()(RestartButtonBase);

export const RestartAddProduct = ({
  mobile: isMobile
}: {
  mobile?: boolean;
}) => {
  const [_, { restart }] = useGlobalStore();
  const { restartLabel } = useModuleProps();

  return (
    <Fragment>
      <div css={isMobile ? mobileContainerStyles : containerStyles}>
        <RestartButton
          text={restartLabel}
          type="secondary"
          onClick={() => {
            restart();
            window.scroll(0, 0);
          }}
          css={restartButtonStyles}
        />
        <AddProduct />
      </div>
    </Fragment>
  );
};
